import { render, staticRenderFns } from "./EllipsisH.vue?vue&type=template&id=6f271d65&"
import script from "./EllipsisH.vue?vue&type=script&lang=js&"
export * from "./EllipsisH.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisH.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports